import React from 'react'
import OriginalAddress, { type IAddressProps } from '../../../Atoms/Address'
import Placeholder from '../../../Atoms/Placeholder'

type AddressProps = Omit<IAddressProps, 'size'> & { hide?: boolean }

const Address = (props: AddressProps) => {
  const { children, hide, ...rest } = props

  if (hide) return null

  return (
    <OriginalAddress {...rest} size="l">
      {children}
    </OriginalAddress>
  )
}

Address.displayName = 'Card.Address'

function AddressPlaceholder() {
  return <Placeholder.Text lines={1} lineHeight="20px" width="80%" />
}

AddressPlaceholder.displayName = 'Card.Address.Placeholder'
Address.Placeholder = AddressPlaceholder

export { Address }
